import _typeof from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/typeof.js";
import "core-js/modules/es6.regexp.split";
import _toConsumableArray from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/toConsumableArray.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import { queryProjectByAreaTree } from '@/api/api'
export default {
  name: 'projectBox',
  data: function data() {
    return {
      treeData: [],
      selectedKeys: [],
      //设置选中的树节点
      checkedKeys: [],
      autoExpandParent: true,
      iExpandedKeys: [],
      visiable: true,
      projectId: ''
    };
  },
  created: function created() {
    var _this = this;

    var that = this;
    window.addEventListener('setItem', function () {
      _this.projectId = sessionStorage.getItem('projectId');
      var areaId = sessionStorage.getItem('areaId');

      if (_this.treeData.length > 0) {
        _this.iExpandedKeys = [_this.treeData[0].key, areaId];
      }

      _this.selectedKeys = [areaId + '-' + _this.projectId];
    }); // this.loadTree()
  },
  methods: {
    loadTree: function loadTree() {
      var _this2 = this;

      var that = this;
      queryProjectByAreaTree().then(function (res) {
        if (res.success) {
          that.treeData = _toConsumableArray(res.result);
          that.projectId = sessionStorage.getItem('projectId');
          var areaId = sessionStorage.getItem('areaId');
          that.iExpandedKeys = [_this2.treeData[0].key, areaId];
          var rex = /^[a-zA-Z]/;

          if (rex.test(_this2.projectId)) {
            if (_this2.projectId) {
              var id = _this2.projectId.split('-')[1];

              that.selectedKeys = [id];
            }
          } else {
            that.selectedKeys = [areaId + '-' + _this2.projectId];
          }
        }
      });
    },
    onSelect: function onSelect(selectedKeys, e, data) {
      if (data) {
        var record = data;
      } else {
        var record = e.node.dataRef;

        if (record.key.indexOf('-') == -1) {
          this.onExpand(record.key, true);
        }
      }

      if (_typeof(record.data) != 'object') {
        this.projectId = record.data;
        this.resetSetItem('projectId', record.data);
        this.resetSetItem('projectName', record.title);
        this.resetSetItem('projectSiteId', record.siteId);

        if (window.location.href.indexOf('/oa/project/projectMap') != -1) {
          this.$router.push('/oa/project/projectDetail');
        }
      } else {
        this.resetSetItem('projectId', 'D-' + record.key);
        this.resetSetItem('projectName', record.title);
        this.resetSetItem('areaId', record.key);
      }

      this.selectedKeys = [record.key];
    },
    onExpand: function onExpand(expandedKeys, isText) {
      this.iExpandedKeys = ['57', expandedKeys];
      this.autoExpandParent = false;
    },
    close: function close() {
      this.visiable = false;
    },
    show: function show() {
      this.visiable = true;
    }
  }
};